import { useState, useEffect, useRef } from "react";

/**
 * Permet de retourner la largeur d'un élément à partir d'une ref (mise à jour si la fenetre est redimensionner)
 */
export function useGetOffsetSize() {
  const ref = useRef(null);
  const [size, setSize] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      if (ref.current) {
        setSize(ref.current.offsetWidth);
      }
    };

    handleResize(); // Initialise la taille

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return [ref, size];
}